module.exports = __webpack_public_path__ + "static/media/undraw_profile_2.afc23243.svg";